/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerSuccessManagerResource
 */
export interface CustomerSuccessManagerResource {
    /**
     * Full name of the customer success manager assigned to the client team
     * @type {string}
     * @memberof CustomerSuccessManagerResource
     */
    fullName: string;
}

/**
 * Check if a given object implements the CustomerSuccessManagerResource interface.
 */
export function instanceOfCustomerSuccessManagerResource(value: object): value is CustomerSuccessManagerResource {
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    return true;
}

export function CustomerSuccessManagerResourceFromJSON(json: any): CustomerSuccessManagerResource {
    return CustomerSuccessManagerResourceFromJSONTyped(json, false);
}

export function CustomerSuccessManagerResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerSuccessManagerResource {
    if (json == null) {
        return json;
    }
    return {
        
        'fullName': json['fullName'],
    };
}

export function CustomerSuccessManagerResourceToJSON(value?: CustomerSuccessManagerResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fullName': value['fullName'],
    };
}

